export default "__VITE_ASSET__BNWNS6KG__"